import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';
import DiffReport from './DiffReport';

export default [AnswerSummary, DiffReport];
